import axios from "axios";
import {API_DOMAIN} from "../constants";

export async function getShiptos(page, size, params) {
    return axios({
        url: API_DOMAIN + "/api/v2/shiptos/adminPortal",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params: {
            page: page,
            size: size,
            ...params,
        },
    });
}

export async function getOrderShiptos(page, size, params) {
    return axios({
        url: API_DOMAIN + "/api/v3/order/shiptos",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params: {
            page: page,
            size: size,
            ...params,
        },
    });
}

export async function getBilltos(page, size, params) {
    return axios({
        url: API_DOMAIN + "/api/v2/billtos/adminPortal",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params: {
            page: page,
            size: size,
            ...params,
        },
    });
}

export async function getSalesRegions(businessUnitCode, userId) {

    const response = await axios({
        url: API_DOMAIN + "/api/v2/ebs/salesRegions",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params: {
            businessUnitCode: businessUnitCode,
            userId: userId
        },
    });

    return response.data;
}

export async function getSalesTerritories(businessUnitCode, salesRegionId) {

    const response = await axios({
        url: API_DOMAIN + "/api/v2/ebs/salesTerritories",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params: {
            businessUnitCode: businessUnitCode,
            salesRegionId: salesRegionId,
        },
    });

    return response.data;
}
